import React from 'react';

// Adicione as imagens da pasta /images/bateria
const bateriaImages = [
  '/images/bateria/bateria1.jpg',
  '/images/bateria/bateria2.jpg',
  '/images/bateria/bateria3.jpg',
  '/images/bateria/bateria4.jpg',
  '/images/bateria/bateria5.jpg'
];

const MercadoLivre = () => (
  <div className="pt-24 bg-gray-100 min-h-screen">
    {/* Hero Section */}
    <section className="py-16 bg-yellow-400 text-center">
      <div className="container mx-auto px-4">
        <img 
          src="https://http2.mlstatic.com/frontend-assets/ml-web-navigation/ui-navigation/5.21.2/mercadolibre/logo__large_plus.png" 
          alt="Logo Mercado Livre" 
          className="h-16 md:h-20 mx-auto mb-6"
        />
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">Nossa Loja Oficial no Mercado Livre</h1>
        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
          Compre com a segurança e a confiança que só a 3E Máquinas e o Mercado Livre podem oferecer. Produtos originais Husqvarna com garantia, entrega rápida e pagamento facilitado.
        </p>
      </div>
    </section>

    {/* Galeria de Imagens de Produtos a Bateria */}
    <section className="py-10 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-husqvarna-dark-gray mb-6 text-center">
          Destaques em Produtos a Bateria Husqvarna
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-8">
          {bateriaImages.map((src, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300 bg-gray-50"
              style={{ minHeight: 0 }}
            >
              <div
                className="w-full flex items-center justify-center"
                style={{
                  aspectRatio: "4/3",
                  width: "100%",
                  maxWidth: "260px",
                  margin: "0 auto",
                  background: "#f3f4f6"
                }}
              >
                {idx === 0 ? (
                  <a
                    href="https://produto.mercadolivre.com.br/MLB-4093622089-motosserra-a-bateria-120i-_JM"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <img
                      src={src}
                      alt={`Produto Husqvarna Bateria ${idx + 1}`}
                      className="object-contain w-full h-full"
                      style={{ maxHeight: "200px", maxWidth: "100%" }}
                      loading="lazy"
                      onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                    />
                  </a>
                ) : idx === 1 ? (
                  <a
                    href="https://produto.mercadolivre.com.br/MLB-5483800074-soprador-a-bateria-120ib-bateria-e-carregador-no-incluso-_JM"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <img
                      src={src}
                      alt={`Produto Husqvarna Bateria ${idx + 1}`}
                      className="object-contain w-full h-full"
                      style={{ maxHeight: "200px", maxWidth: "100%" }}
                      loading="lazy"
                      onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                    />
                  </a>
                ) : idx === 2 ? (
                  <a
                    href="https://produto.mercadolivre.com.br/MLB-5263720174-motosserra-husqvarna-a-bateria-240i-sem-bateriacarregador-_JM?pdp_filters=seller_id%3A53613158#polycard_client=search-nordic&position=8&search_layout=grid&type=item&tracking_id=4085d0c8-9f1e-44c8-ae64-b7630fc7b947&wid=MLB5263720174&sid=search"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <img
                      src={src}
                      alt={`Produto Husqvarna Bateria ${idx + 1}`}
                      className="object-contain w-full h-full"
                      style={{ maxHeight: "200px", maxWidth: "100%" }}
                      loading="lazy"
                      onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                    />
                  </a>
                ) : idx === 3 ? (
                  <a
                    href="https://produto.mercadolivre.com.br/MLB-5483937460-rocadeira-a-bateria-535irx-husqvarna-_JM"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <img
                      src={src}
                      alt={`Produto Husqvarna Bateria ${idx + 1}`}
                      className="object-contain w-full h-full"
                      style={{ maxHeight: "200px", maxWidth: "100%" }}
                      loading="lazy"
                      onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                    />
                  </a>
                ) : idx === 4 ? (
                  <a
                    href="https://produto.mercadolivre.com.br/MLB-4113945565-motosserra-husqvarna-bateria540ixpsem-bateria-e-carregador-_JM"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <img
                      src={src}
                      alt={`Produto Husqvarna Bateria ${idx + 1}`}
                      className="object-contain w-full h-full"
                      style={{ maxHeight: "200px", maxWidth: "100%" }}
                      loading="lazy"
                      onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                    />
                  </a>
                ) : (
                  <img
                    src={src}
                    alt={`Produto Husqvarna Bateria ${idx + 1}`}
                    className="object-contain w-full h-full"
                    style={{ maxHeight: "200px", maxWidth: "100%" }}
                    loading="lazy"
                    onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                  />
                )}
              </div>
              {idx === 0 && (
                <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                  Motosserra A Bateria 120i
                </div>
              )}
              {idx === 1 && (
                <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                  Soprador à Bateria 120iB
                </div>
              )}
              {idx === 2 && (
                <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                  Motosserra à Bateria 240i
                </div>
              )}
              {idx === 3 && (
                <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                  Roçadeira à Bateria 535iRX
                </div>
              )}
              {idx === 4 && (
                <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                  Motosserra à Bateria 540iXP
                </div>
              )}
            </div>
          ))}
        </div>
        <p className="text-center text-lg text-husqvarna-dark-gray/80 mb-4">
          Produtos a bateria: tecnologia, sustentabilidade e praticidade para o seu dia a dia.
        </p>
      </div>
    </section>

    {/* CTA Section */}
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-husqvarna-dark-gray mb-4">Tudo o que você precisa, a um clique de distância.</h2>
        <p className="text-lg text-husqvarna-dark-gray/80 mb-8">
          Acesse nossa loja oficial e confira nosso catálogo completo de produtos, peças e acessórios Husqvarna.
        </p>
        <a
          href="https://www.mercadolivre.com.br/pagina/3emaquinas"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-full shadow transition-colors duration-300 text-xl"
        >
          Acesse nossa loja Mercado Livre
        </a>
      </div>
    </section>
  </div>
);

export default MercadoLivre;